module.exports = __webpack_public_path__ + "img/timer-white.59f19c00.svg";